import React, { Component } from 'react';

class ExamTimer extends Component {
    render() {
        return (
            <div className="exam-time-info-wrap">
                <span className="icon-wrap">
                    <svg className="icon time-icon" xmlns="http://www.w3.org/2000/svg" viewBox="4 4 16 16">
                        <g transform="translate(-270 -146)">
                            <path className="fill" d="M282,150a8,8,0,1,0,8,8A8.009,8.009,0,0,0,282,150Zm0,14.222A6.222,6.222,0,1,1,288.222,158,6.229,6.229,0,0,1,282,164.222Z" fill="#fff"/>
                            <path className="fill" d="M286,157.111h-3.973l-2.165-1.6a.889.889,0,0,0-1.058,1.429l2.4,1.777a.889.889,0,0,0,.53.175H286a.889.889,0,1,0,0-1.778Z" fill="#fff"/>
                        </g>
                    </svg>
                </span>
                <div className="time-info">
                    <span>제한 시간 : 5분</span>
                    <span>남은 시간 : 4분 30초</span>
                </div>
            </div>
        );
    }
}

export default ExamTimer;